module.exports = __webpack_public_path__ + "static/media/Paris.2ee636b1.png";